import React from 'react';
import PrimarySectionHeader from 'commonComponents/Headers/PrimarySectionHeader/PrimarySectionHeader';
import { importAllImagesFromFolder } from 'lib/utils/imagesUtils';
import styles from './TextWithImages.module.scss';

const TextWithImages = ({
  header,
  subheader,
  anchor,
  content,
  context
}) => {
  const images = importAllImagesFromFolder(context);
  const headerProps = { header, subheader, anchor };

  return ( 
    <section className={ styles.TextWithImages }>
      <PrimarySectionHeader { ...headerProps } />
      <div className={ styles.content }>
        { content && content.map(({ title, text }, i) =>
          <div className={ styles.row } key={ i }>
            <figure>
              <img src={ images[i] } />
            </figure>
            <article>
              <h2>{ title }</h2>
              <p>{ text }</p>
            </article>
          </div>
        ) }
      </div>
    </section>
  );
};
 
export default TextWithImages;